import { Dimensions, Platform } from 'react-native';

import { Edge } from 'react-native-safe-area-context';

import { EPGAlignment, EPGConfig } from 'custom_modules/react-native-epg';

import { COLOR } from 'utils/colors';
import { isTabletOrWeb, widthPercentageToDP } from 'utils/responsiveness';

export const edges: Edge[] = ['left', 'right'];

const WINDOW = Dimensions.get('window');
const CHANNEL_WIDTH = 100;
export const ROW_HEIGHT = 48;
const EPG_CONTAINER_PADDING = Platform.select({
    web: widthPercentageToDP(72),
    default: 0,
});
export const HOURS_IN_VIEWPORT = isTabletOrWeb ? 2 : 0.75;
const HOUR_WIDTH =
    (WINDOW.width - CHANNEL_WIDTH - EPG_CONTAINER_PADDING * 2) /
    HOURS_IN_VIEWPORT;

export const PRIME_TIME = 19;

export const CONFIG: Partial<EPGConfig> = {
    cellBorderRadius: 4,
    padding: 2,
    channelWidth: CHANNEL_WIDTH,
    timebarHeight: 48,
    rowHeight: ROW_HEIGHT,
    hourWidth: HOUR_WIDTH,
    markerToLineAlignment: EPGAlignment.start,
    stickyMarkerPadding: 8,
    stickyPrograms: !Platform.isTV,
    hoursCount: 24,
    paddingColor: COLOR.BLACK,
    skeletonCellsColor: COLOR.COD_GRAY_LIGHT,
};
